import { COMPANY } from "@/config";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-sefco-bg border-t border-neutral-800 pt-20 pb-10 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
          <div>
          <div className="mb-4">
            <img src={COMPANY.logo} alt="Sefco logo" className="h-12 w-auto" />
          </div>
            <p className="text-zinc-400 max-w-xs leading-relaxed">{COMPANY.tagline}. Al meer dan 25 jaar de referentie voor platte daken.</p>
          </div>
          <div>
            <div className="text-sm uppercase tracking-wider text-zinc-500 mb-4">Contact</div>
            <ul className="space-y-2 text-zinc-300">
              <li><a href={`mailto:${COMPANY.email}`} className="hover:text-sefco-blue transition-colors">{COMPANY.email}</a></li>
              <li>{COMPANY.address}</li>
              <li>{COMPANY.phone || COMPANY.phoneDisplay}</li>
            </ul>
          </div>
          <div>
            <div className="text-sm uppercase tracking-wider text-zinc-500 mb-4">Bedrijf</div>
            <ul className="space-y-2 text-zinc-300">
              <li>Ondernemingsnr. {COMPANY.ondernemingsnummer}</li>
              <li>Actief in Vlaanderen & Brussel</li>
              <li>Bitumen · EPDM · Isolatie</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-zinc-500">© {new Date().getFullYear()} {COMPANY.name}. Alle rechten voorbehouden.</p>
          <p className="text-sm text-zinc-500">Ondernemingsnummer {COMPANY.ondernemingsnummer}</p>
        </div>
      </div>

      <div className="mt-12 select-none pointer-events-none">
        <div className="font-heading font-black text-[22vw] leading-none text-neutral-900 text-center tracking-tighter">
          SEFCO
        </div>
      </div>
    </footer>
  );
};
